import { StyleSheet } from 'react-native';

export const dropdownStyling = {
  container: {
    minHeight: 32,
    maxHeight: 32,
    borderRadius: 16,
    borderWidth: 1,
    width: 140,
    minWidth: 200,
    borderColor: '#8F95A4',
    backgroundColor: '#F8F9FA'
  },

  dropDownText: {
    marginEnd: 0
  },
  icon: {
    height: 22
  },
  optionContainer: {
    minWidth: 150,
    maxWidth: 300
  }
};
export const additionalMetrixStyling = theme => {
  return StyleSheet.create({
    selectedMetrixContainer: {
      borderWidth: 1,
      borderRadius: 20,
      paddingVertical: 6,
      paddingHorizontal: 15,
      width: 250,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 10,
      marginLeft: 60
    }
  });
};
export const emojiMapStyling = theme => {
  return StyleSheet.create({
    container: {
      position: 'relative'
    },
    subIcon: {
      position: 'absolute',
      bottom: -10,
      left: -5,
      backgroundColor: 'white',
      borderRadius: 10,
      width: 20,
      height: 20,
      alignItems: 'center',
      justifyContent: 'center',
      paddingLeft: 3
    }
  });
};
